import React from "react";

import { Image } from "../../../common/Image";
import { IProduct } from "../../../models/catalogue";

interface IProps {
    rootProduct: IProduct | null;
    variant: IProduct | null;
}

export const GiftMainImage = ({
    rootProduct,
    variant,
}: IProps): React.JSX.Element | null => {
    if (!rootProduct) {
        return null;
    }
    let images: IProduct["images"] = [];
    if (variant) {
        images = images.concat(variant.images);
    }
    images = images.concat(rootProduct.images);
    if (images.length <= 0) {
        return null;
    }
    // TODO(i18n): "Product Tile" is a hardcoded role name that may need translation if displayed to users or if role names are localized
    const image = images.filter((img) => {
        return img.role === "Product Tile";
    })[0];
    const altText = variant ? variant.title : rootProduct.title;
    return (
        <Image className="gift-main-image" src={image.original} alt={altText} />
    );
};
